import React from 'react';

import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';

function AutocompleteBordered<
    T,
    Multiple extends boolean | undefined = undefined,
    DisableClearable extends boolean | undefined = undefined,
    FreeSolo extends boolean | undefined = undefined
>(props: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>) {
    return (
        <Autocomplete
            {...props}
            componentsProps={{
                paper: {
                    sx: { borderColor: 'primary.main', borderWidth: '2px', borderStyle: 'solid' }
                }
            }}
        />
    );
}

export default AutocompleteBordered;
